import type { FC } from 'react';
import { Checkbox } from '@THC/components/Checkbox';
import { useStore } from 'zustand';

import { IconTooltip } from 'Components/shared/IconTooltip';
import { EmailBodyStore, emailEditorService } from 'Features/SellerCommunications/services';
import { T } from 'Features/SellerCommunications/utils/translate';
import {
	triggerSellerMessagingSaveDefaultBodyCheckboxSelectedEvent,
	triggerSellerMessagingSaveDefaultBodyTooltipHoveredEvent,
} from 'Services/analytics/events';

import styles from './EmailForm.module.scss';

export const EmailSaveAsDefaultCopySection: FC = () => {
	const { saveAsDefaultBody } = useStore(EmailBodyStore);

	const handleSaveAsDefaultChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		emailEditorService.onSaveAsDefaultChange(e.target.checked);
		triggerSellerMessagingSaveDefaultBodyCheckboxSelectedEvent(e.target.checked);
	};

	return (
		<section className={styles.saveAsDefaultCopy}>
			<Checkbox
				formProps={{
					input: {
						checked: saveAsDefaultBody,
						onChange: handleSaveAsDefaultChange,
					},
				}}
				id="saveAsDefaultCopy"
				label={T.translate('createEmail.saveAsDefaultCopy.label')}
			/>
			<div className={styles.iconWrapper}>
				<IconTooltip
					content={T.translate('createEmail.saveAsDefaultCopy.tooltip')}
					iconProps={{ filled: true, id: 'saveAsDefaultCopyTooltip', size: 'xsmall' }}
					maxWidth={'288px'}
					onMouseEnter={triggerSellerMessagingSaveDefaultBodyTooltipHoveredEvent}
					side="top"
				/>
			</div>
		</section>
	);
};
